import { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MediaType } from '@volcengine/rtc';
import { Switch, Select } from '@arco-design/web-react';
import DrawerRowItem from '@/components/DrawerRowItem';
import { RootState } from '@/store';
import RtcClient from '@/lib/RtcClient';
import { useDeviceState } from '@/lib/useCommon';
import { updateSelectedDevice } from '@/store/slices/device';
import { isMobile } from '@/utils/utils';
import styles from './index.module.less';

interface IDeviceDrawerButtonProps {}

const DEVICE_NAME = {
  [MediaType.AUDIO]: '麦克风',
  [MediaType.VIDEO]: '摄像头',
};

function DeviceDrawerButton(props: IDeviceDrawerButtonProps) {
  // 视频业务已下线，此组件恒使用 AUDIO 配置
  const device = useDeviceState();
  const isEnable = device.isAudioPublished;
  const switcher = device.switchMic;
  const devicePermissions = useSelector((state: RootState) => state.device.devicePermissions);
  const devices = useSelector((state: RootState) => state.device);
  const selectedDevice = devices.selectedMicrophone;
  const permission = devicePermissions?.audio;

  const SETTING_NAME = {
    [MediaType.AUDIO]: '麦克风',
    [MediaType.VIDEO]: '视频',
  };

  const dispatch = useDispatch();
  const deviceList = useMemo(() => devices.audioInputs, [devices]);

  const handleDeviceChange = (value: string) => {
    RtcClient.switchDevice(MediaType.AUDIO, value);
    dispatch(
      updateSelectedDevice({
        selectedMicrophone: value,
      })
    );
  };

  return (
    <DrawerRowItem
      btnText={`${SETTING_NAME[MediaType.AUDIO]}设置`}
      drawer={{
        width: isMobile() ? '100%' : undefined,
        title: `${SETTING_NAME[MediaType.AUDIO]}设置`,
        footer: null,
        children: (
          <div className={styles.wrapper}>
            <div className={styles.label}>{DEVICE_NAME[MediaType.AUDIO]}</div>
            <div className={styles.value}>
              <Switch
                checked={isEnable}
                size="small"
                onChange={(enable) => switcher(enable)}
                disabled={!permission}
              />
              <Select
                className={styles.selectWide}
                value={selectedDevice}
                onChange={handleDeviceChange}
              >
                {deviceList.map((device) => (
                  <Select.Option key={device.deviceId} value={device.deviceId}>
                    {device.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
        ),
      }}
    />
  );
}

export default DeviceDrawerButton;
